import PropTypes from 'prop-types'
import { ChecklistItemCategory } from '../../models/checklists/checklist-item-category-enum'

/**
 * @typedef {Object} ChecklistItem
 * @property {Object} definition - The definition of the checklist item.
 * @property {number} definition.id - The id of the checklist item.
 * @property {string} definition.stringCode - The string code to translate the name of the checklist item.
 * @property {string} definition.name - The name of the checklist item
 * @property {string} definition.category - Type of the checklist item, can be one of
 *     INTERNAL
 *     EXTERNAL
 *
 * @property {Object} definition.icon - The specificaction of the icon related to the checklist item
 * @property {number} definition.icon.id - The id of the icon related to the checklist item
 * @property {string} definition.icon.name - The name of the icon related to the checklist item
 * @property {string} definition.icon.url - The url of the icon related to the checklist item
 * @property {boolean} mandatory - Is mandatory to mark the checklist item?
 * @property {boolean} vehicleNotRoadworthy - Does this checklist item make not roadworthy the vehicle when it is marked
 *     as defective?
 * @property {number} position - The position in the checklist of the checklist item
 */
export const checklistItemPropType = PropTypes.shape({
    definition: PropTypes.shape({
        category: PropTypes.oneOf([ChecklistItemCategory.INTERNAL, ChecklistItemCategory.EXTERNAL]),
        icon: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            url: PropTypes.string
        }),
        id: PropTypes.number,
        name: PropTypes.string,
        stringCode: PropTypes.string
    }),
    mandatory: PropTypes.bool,
    position: PropTypes.number,
    vehicleNotRoadworthy: PropTypes.bool
})
